module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp3_7005.4a9422c8.png";